
import { 
  UpgradableNumber 
} from "@dndModels/misc";
import { FloatingFeature } from "@models";
import { BonusSpells } from "@dndModels/feature/BonusSpells";
import { ProficiencyType } from "@dndModels/Types";

export class Proficiency extends FloatingFeature {
  proficiency_types: ProficiencyType[] = [];
  tool_types: string[] = [];
  choice_count = 1;
  double = false;
  the_proficiencies: ProficiencySimple[] = [];
  alternates: ProficiencySimple[] = [];
  suggestions: ProficiencySimple[] = [];
  prof_or_exp = false;
  extra_bonus: UpgradableNumber = new UpgradableNumber();

  // common_util: DataUtilitiesClass;

  constructor(obj?: any) {
    super(obj);
    // this.common_util = DataUtilities.getInstance();
    if (obj) {
      // console.log(obj);
      this.proficiency_types = obj.proficiency_types ? [...obj.proficiency_types] : [];
      if (this.proficiency_types.length === 0) {
        switch (this.feature_type as string) {
          case "Tool Proficiency":
          case "Tool Proficiencies":
          case "Tool Proficiency Choices":
            this.proficiency_types.push("Tool");
          break;
          case "Skill Proficiency":
          case "Skill Proficiencies":
          case "Skill Proficiency Choices":
            this.proficiency_types.push("Skill");
          break;
          case "Armor Proficiencies":
            this.proficiency_types.push("Armor");
          break;
          case "Weapon Proficiencies":
            this.proficiency_types.push("Weapon");
          break;
          case "Special Weapon Proficiencies":
            this.proficiency_types.push("Special");
          break;
          case "Saving Throw Proficiencies":
            this.proficiency_types.push("Saving Throw");
          break;
          case "Expertise":
            this.proficiency_types.push("Skill");
          break;
          default:
            this.proficiency_types.push(this.feature_type as ProficiencyType);
          break;
        }
      }
      if (this.proficiency_types.includes("Special Weapon")) {
        this.proficiency_types = this.proficiency_types.filter(o => o !== "Special Weapon");
        this.proficiency_types.push("Special");
      }
      this.feature_type = obj.feature_type === "Expertise" ? "Expertise" : "Proficiencies";
      this.the_proficiencies = [];
      let the_proficiencies: string[] = [];
      let alternates: string[] = [];
      this.choice_count = obj.choice_count !== undefined ? +obj.choice_count : 1;
      this.double = obj.double ? obj.double : false;
      if (obj.the_proficiencies && obj.the_proficiencies.length > 0) {
        if (typeof(obj.the_proficiencies[0]) === "object") {
          this.the_proficiencies = [];
          for (const the_proficiency of (obj.the_proficiencies as any[])) {
            if (this.the_proficiencies.filter(o => o.proficiency_id !== the_proficiency.proficiency_id)) {
              this.the_proficiencies.push(the_proficiency);
            }
          }
        } else {
          the_proficiencies = obj.the_proficiencies ? [...obj.the_proficiencies] : [];
        }
      }
      if (obj.alternates && obj.alternates.length > 0) {
        if (typeof(obj.alternates[0]) === "object") {
          this.alternates = [];
          for (const alternate of (obj.alternates as any[])) {
            if (this.alternates.filter(o => o.proficiency_id !== alternate.proficiency_id)) {
              this.alternates.push(alternate);
            }
          }
        } else {
          alternates = obj.alternates ? [...obj.alternates] : [];
        }
      }
      
      this.tool_types = [];
      if (obj.tool_types) {
        obj.tool_types.forEach((type: string) => {
          if (!this.tool_types.includes(type)) {
            this.tool_types.push(type);
          }
        });
      }
      // this.double = this.feature_type === "Expertise" ? true : this.double;
      if (the_proficiencies.length > 0 && this.proficiency_types.length === 1) {
        the_proficiencies.filter(o => o !== "").forEach(prof_id => {
          if (["Gaming Set", "Artisan's Tools", "Musical Instrument", "Specialty Tool", "Other Tool"].includes(prof_id)) {
            if (!this.tool_types.includes(prof_id)) {
              this.tool_types.push(prof_id);
            }
          } else {
            if (this.the_proficiencies.filter(o => o.proficiency_id !== prof_id)) {
              this.the_proficiencies.push({ 
                proficiency_id: prof_id, 
                type: this.proficiency_types[0],
                proficiency_level: this.double ? 2 : 1
              });
            }
          }
        });
      }
      if (alternates.length > 0 && this.alternates.length === 1) {
        alternates.filter(o => o !== "").forEach(prof_id => {
          if (this.alternates.filter(o => o.proficiency_id !== prof_id)) {
            this.alternates.push({ 
              proficiency_id: prof_id, 
              type: this.proficiency_types[0],
              proficiency_level: this.double ? 2 : 1
            });
          }
        });
      }
      this.the_proficiencies.forEach(the_prof => {
        if (the_prof.type === undefined || the_prof.type === "") {
          the_prof.type = this.proficiency_types[0];
        }
      });
      // This was to detect proficiencies that had duplicates.
      // const new_the_proficiencies: ProficiencySimple[] = [];
      // for (const the_prof of this.the_proficiencies) {
      //   if (new_the_proficiencies.filter(o => o.proficiency_id === the_prof.proficiency_id).length === 0) {
      //     new_the_proficiencies.push(the_prof);
      //   }
      // }
      // if (new_the_proficiencies.length !== this.the_proficiencies.length) {
      //   debugger;
      // }
      this.alternates.forEach(the_prof => {
        if (the_prof.type === undefined || the_prof.type === "") {
          the_prof.type = this.proficiency_types[0];
        }
      });
      this.suggestions = [];
      if (obj.suggestions) {
        this.suggestions = [...obj.suggestions];
      }
      this.prof_or_exp = obj.prof_or_exp ? obj.prof_or_exp : false;
      if (this.choice_count === 0) {
        this.choice_count = obj.num ? +obj.num : this.the_proficiencies.length;
      }
      this.extra_bonus = obj.extra_bonus ? new UpgradableNumber(obj.extra_bonus) : new UpgradableNumber();
      if (this.proficiency_types.length === 1 && this.proficiency_types.includes("Weapon")) {
        if (this.the_proficiencies.length !== this.choice_count) {
          this.choice_count = this.the_proficiencies.length;
        }
      }
    }
  }

  // load(obj: any): void {
  //   super.load(obj);
  //   if (obj) {
  //     this.proficiency_types = obj.proficiency_types ? [...obj.proficiency_types] : [];
  //     if (this.proficiency_types.length === 0) {
  //       switch (this.feature_type as string) {
  //         case "Tool Proficiency":
  //         case "Tool Proficiencies":
  //         case "Tool Proficiency Choices":
  //           this.proficiency_types.push("Tool");
  //         break;
  //         case "Skill Proficiency":
  //         case "Skill Proficiencies":
  //         case "Skill Proficiency Choices":
  //           this.proficiency_types.push("Skill");
  //         break;
  //         case "Armor Proficiencies":
  //           this.proficiency_types.push("Armor");
  //         break;
  //         case "Weapon Proficiencies":
  //           this.proficiency_types.push("Weapon");
  //         break;
  //         case "Special Weapon Proficiencies":
  //           this.proficiency_types.push("Special");
  //         break;
  //         case "Saving Throw Proficiencies":
  //           this.proficiency_types.push("Saving Throw");
  //         break;
  //         case "Expertise":
  //           this.proficiency_types.push("Skill");
  //         break;
  //         default:
  //           this.proficiency_types.push(this.feature_type);
  //         break;
  //       }
  //     }
  //     if (this.proficiency_types.includes("Special Weapon")) {
  //       this.proficiency_types = this.proficiency_types.filter(o => o !== "Special Weapon");
  //       this.proficiency_types.push("Special");
  //     }
  //     this.feature_type = obj.feature_type === "Expertise" ? "Expertise" : "Proficiencies";
  //     this.the_proficiencies = [];
  //     let the_proficiencies: string[] = [];
  //     let alternates: string[] = [];
  //     this.choice_count = obj.choice_count !== undefined ? +obj.choice_count : 1;
  //     this.double = obj.double ? obj.double : false;
  //     if (obj.the_proficiencies && obj.the_proficiencies.length > 0) {
  //       if (typeof(obj.the_proficiencies[0]) === "object") {
  //         this.the_proficiencies = [];
  //         for (const the_proficiency of (obj.the_proficiencies as any[])) {
  //           if (this.the_proficiencies.filter(o => o.proficiency_id !== the_proficiency.proficiency_id)) {
  //             this.the_proficiencies.push(the_proficiency);
  //           }
  //         }
  //       } else {
  //         the_proficiencies = obj.the_proficiencies ? [...obj.the_proficiencies] : [];
  //       }
  //     }
  //     if (obj.alternates && obj.alternates.length > 0) {
  //       if (typeof(obj.alternates[0]) === "object") {
  //         this.alternates = [];
  //         for (const alternate of (obj.alternates as any[])) {
  //           if (this.alternates.filter(o => o.proficiency_id !== alternate.proficiency_id)) {
  //             this.alternates.push(alternate);
  //           }
  //         }
  //       } else {
  //         alternates = obj.alternates ? [...obj.alternates] : [];
  //       }
  //     }
      
  //     this.tool_types = [];
  //     if (obj.tool_types) {
  //       obj.tool_types.forEach((type: string) => {
  //         if (!this.tool_types.includes(type)) {
  //           this.tool_types.push(type);
  //         }
  //       });
  //     }
  //     // this.double = this.feature_type === "Expertise" ? true : this.double;
  //     if (the_proficiencies.length > 0 && this.proficiency_types.length === 1) {
  //       the_proficiencies.filter(o => o !== "").forEach(prof_id => {
  //         if (["Gaming Set", "Artisan's Tools", "Musical Instrument", "Specialty Tool", "Other Tool"].includes(prof_id)) {
  //           if (!this.tool_types.includes(prof_id)) {
  //             this.tool_types.push(prof_id);
  //           }
  //         } else {
  //           if (this.the_proficiencies.filter(o => o.proficiency_id !== prof_id)) {
  //             this.the_proficiencies.push({ 
  //               proficiency_id: prof_id, 
  //               type: this.proficiency_types[0],
  //               proficiency_level: this.double ? 2 : 1
  //             });
  //           }
  //         }
  //       });
  //     }
  //     if (alternates.length > 0 && this.alternates.length === 1) {
  //       alternates.filter(o => o !== "").forEach(prof_id => {
  //         if (this.alternates.filter(o => o.proficiency_id !== prof_id)) {
  //           this.alternates.push({ 
  //             proficiency_id: prof_id, 
  //             type: this.proficiency_types[0],
  //             proficiency_level: this.double ? 2 : 1
  //           });
  //         }
  //       });
  //     }
  //     this.the_proficiencies.forEach(the_prof => {
  //       if (the_prof.type === undefined || the_prof.type === "") {
  //         the_prof.type = this.proficiency_types[0];
  //       }
  //     });
  //     // This was to detect proficiencies that had duplicates.
  //     // const new_the_proficiencies: ProficiencySimple[] = [];
  //     // for (const the_prof of this.the_proficiencies) {
  //     //   if (new_the_proficiencies.filter(o => o.proficiency_id === the_prof.proficiency_id).length === 0) {
  //     //     new_the_proficiencies.push(the_prof);
  //     //   }
  //     // }
  //     // if (new_the_proficiencies.length !== this.the_proficiencies.length) {
  //     //   debugger;
  //     // }
  //     this.alternates.forEach(the_prof => {
  //       if (the_prof.type === undefined || the_prof.type === "") {
  //         the_prof.type = this.proficiency_types[0];
  //       }
  //     });
  //     this.suggestions = [];
  //     if (obj.suggestions) {
  //       this.suggestions = [...obj.suggestions];
  //     }
  //     this.prof_or_exp = obj.prof_or_exp ? obj.prof_or_exp : false;
  //     if (this.choice_count === 0) {
  //       this.choice_count = obj.num ? +obj.num : this.the_proficiencies.length;
  //     }
  //     this.extra_bonus = obj.extra_bonus ? new UpgradableNumber(obj.extra_bonus) : new UpgradableNumber();
  //     if (this.proficiency_types.length === 1 && this.proficiency_types.includes("Weapon")) {
  //       if (this.the_proficiencies.length !== this.choice_count) {
  //         this.choice_count = this.the_proficiencies.length;
  //       }
  //     }
  //   }
  // }

  toDBObj(): any {
    const db_obj = super.toDBObj();
    return {
      ...db_obj,
      proficiency_types: this.proficiency_types,
      choice_count: this.choice_count,
      double: this.double,
      the_proficiencies: this.the_proficiencies,
      alternates: this.alternates,
      suggestions: this.suggestions,
      prof_or_exp: this.prof_or_exp,
      tool_types: this.tool_types,
      extra_bonus: this.extra_bonus.toDBObj()
    };
  }

  copy(copyMe: FloatingFeature, drop_ids = false): void {
    super.copy(copyMe, drop_ids);
    if (copyMe instanceof Proficiency) {
      this.safe_copy(copyMe);
    }
  }

  safe_copy(copyMe: Proficiency) {
    this.proficiency_types = [...copyMe.proficiency_types];
    this.choice_count = copyMe.choice_count;
    this.double = copyMe.double;
    this.the_proficiencies = [...copyMe.the_proficiencies];
    this.alternates = [...copyMe.alternates];
    this.suggestions = [...copyMe.suggestions];
    this.tool_types = [...copyMe.tool_types];
    this.prof_or_exp = copyMe.prof_or_exp;
    this.extra_bonus = copyMe.extra_bonus.clone();
  }

  clone(drop_ids = false): Proficiency {
    const new_obj = new Proficiency();
    new_obj.copy(this, drop_ids);
    return new_obj;
  }

  get the_ids() {
    return this.the_proficiencies.map(o => { return o.proficiency_id; });
  }

  get alternate_ids() {
    return this.alternates.map(o => { return o.proficiency_id; });
  }
}

export interface ProficiencySimple {
  proficiency_id: string; // Id of the Skill or Tool that this is for
  proficiency_level: number; // 1 = Proficient, 2 = Expertise
  type: string; // Skill, Expertise, or Tool
} 

export interface CharacterProficiency {
  prof_feature_id: string; // Feature.true_id of the feature granting this proficiency
  expertise_feature_id: string; // Feature.true_id of the feature granting this expertise
  proficiency_id: string; // Id of the Skill or Tool that this is for
  proficiency_level: number; // 1 = Proficient, 2 = Expertise
  type: string; // Skill, Expertise, or Tool
  extra_bonus: number;
} 

export class CharacterBonusSpells {
  cf_id = "";
  ff_id = "";
  selected_spell_id_for_given_id: { [given_id: string]: string } = {};
  ff: BonusSpells | null = null;
  classless = false;

  constructor(obj?: any) {
    if (obj) {
      this.cf_id = obj.cf_id ? obj.cf_id : "";
      this.ff_id = obj.ff_id ? obj.ff_id : "";
      this.selected_spell_id_for_given_id = obj.selected_spell_id_for_given_id ? obj.selected_spell_id_for_given_id : {};
      this.classless = obj.classless ? obj.classless : false;
    }
  }

  toDBObj() {
    return {
      cf_id: this.cf_id,
      ff_id: this.ff_id,
      selected_spell_id_for_given_id: this.selected_spell_id_for_given_id,
      classless: this.classless
    }
  }

  copy(copyMe: CharacterBonusSpells) {
    this.cf_id = copyMe.cf_id;
    this.ff_id = copyMe.ff_id;
    this.selected_spell_id_for_given_id = {...copyMe.selected_spell_id_for_given_id};
    this.ff = copyMe.ff;
    this.classless = copyMe.classless;
  }

  clone() {
    const clone = new CharacterBonusSpells();
    clone.copy(this);
    return clone;
  }
}

export function isCharacterProficiency(v: any): v is CharacterProficiency {
  return typeof v === 'object' && v !== null
  	&& typeof v.prof_feature_id === 'string'
    && typeof v.expertise_feature_id === 'string'
    && typeof v.proficiency_id === 'string'
    && typeof v.proficiency_level === 'number'
    && typeof v.type === 'string'
    && typeof v.extra_bonus === 'number';
}
